import { Component, OnInit,ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActionSheetController,IonInfiniteScroll} from '@ionic/angular';
import { HttpCustomerService, MessageclientService, WxjssdkService } from 'src/service';
import { WebParameterContext } from '../../../../../model/common';
import { CommonService } from '../../../../../service/common.service';
import { GridBaseCase } from '../../../grid/grid.base.case';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
declare var wx: any;//启用微信客户端
declare var app;
@Component({
  selector: 'app-content-library-detail',
  templateUrl: './content-library-detail.component.html',
  styleUrls: ['./content-library-detail.component.scss']
})
export class ContentLibraryDetailComponent extends GridBaseCase implements OnInit {
  articleInfo: any = [];
  listtype: any; // 所属类别
  a_ID: any; // 文章id
  dataArrayList: Array<any> = [];//数据列表
  a_Title:any;
  a_ArticleContent:any; // 文章内容
  a_CreateTime:any; // 发布时间
  transmitUrl:string="";//转发微信链接
  imgUrl:string="";//分享的图片地址
  isCollect: boolean = false;
  clickCollect:boolean = false;//点击收藏
  configWX:any={
    title: "", // 分享标题
    // desc: that.a_ArticleContent, // 分享描述
    link: "", // 分享链接
    imgUrl:""//分享图标
  };//微信转发基础配置
  guId:any;
  ConfigNametwo:{};

  fileIcon:any;// 图标
  fileUrl: any; // 附件路径
  fileName:any; // 文件名称
  isCanForward:boolean; // 判断是否显示微信
  fileIconnum:number;  // 是否显示某个图标
  isCanForwardposters:boolean = false; // 是否显示海报按钮
  QYWXQRCodestyle:any; // 海报地址
 
  QYWXQRCodestyleposters:any; // 二维码路径
@ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  constructor(
    private router: ActivatedRoute,
    private http: HttpCustomerService,
    private com: CommonService,
    private msg:   MessageclientService,
    private actionSheet: ActionSheetController,
    private weixin:WxjssdkService,
    private iab:InAppBrowser
  ) {
    super();
    this.router.queryParams.subscribe(queryParams => {
      console.log(queryParams, "获取的参数集合");
      this.listtype = queryParams.type || null; // 类型 1：首页搜索列表 2：我的收藏 3：浏览历史
      this.a_ID = queryParams.a_ID || null; // 文章id
    });
    try{
          this.getCollectStatus();
        console.log(this.listtype);
        console.log(this.a_ID);
        
    }catch(err){

    }
  }
  ngAfterViewInit(){
    this.addSNCArticleHistory(this.a_ID,false);
    console.log(this.com.GetAccount,"拿到的数据*****");
    console.log(this.com.GetAccount["QYWXQRCode"]);
   this.QYWXQRCodestyleposters = this.com.GetAccount["QYWXQRCode"];
  }
  downuploadData(){
      const that = this;
      if(that.com.isWeixinIOS){
        that.com.setHistoryUrl(false);
        that.iab.create(that.fileUrl);
      }else if(that.com.isWeixinAndroid){//如果是android
          that.weixin.GetpreviewFile(that.ConfigNametwo).then(data=>{
        }).catch(err=>{
          that.msg.Alert("文件打开失败,请联系系统管理员");
        });
      }else{
        // let _fileUrl:any= encodeURI(that.fileUrl);
        that.iab.create(that.fileUrl);
      }
   }
  loadMoreData(e){
    const that= this;
    this.infiniteScroll.disabled = true;
    this.addSNCArticleHistory(that.a_ID,true);
  }
 // 添加浏览历史记录
 addSNCArticleHistory(a_ID,IsReadAll:boolean){
  const that = this;
  let _obj = {};
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  body.ConfigName = "AddSNCArticleHistory";
  body.OpType = "query";
  body.ConfigType = "view";
  body.PageNumber = 1;
  body.Client.ApiType = "Element";
  body.Client.ClientType = 2;
  _obj={
    "articleID":that.a_ID,
    "IsReadAll":IsReadAll
  }
  body.RequestBody = JSON.stringify(_obj);
  that.http.post(app.DEFAULTURL, body).then(data => {
    if (data.ResponseMessage.Success) {
      console.log(data);
    } else {
      that.msg.Alert(data.ResponseMessage.ErrorMessage);
    }
  }).catch(error => {
    console.log(error);
  });
}
  LoadData(PageNumber) {
    var that = this;
    const PageName = that.router.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "TBArticleContentXML";
    body.ConfigType = "view";
    body.OpType = "GET";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    let typeObj = {
      "a_ID": that.a_ID
    };

    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        console.log(data);
          that.dataArrayList = [];
          that.apiObj['status'] = data.ResponseMessage.Success;
          that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
          that.loading = true;
        that.dataArrayList = data.Status;
        let item:any=that.dataArrayList;
          that.articleInfo = [
            { id: item.c_ID, text: "一级分类", value: item.c_Name || "--" },
            { id: item.d_ID, text: "二级分类", value: item.d_Name || "--" },
            { text: "搜索关键字", value: item.b_TagName || "暂无关键字" },
            { text: "浏览量", value: item.a_ReadQuantity || 0 },
            // { text: "打开率", value: item.a_OpenRate || 0 },
            { text: "关联产品", value: item.a_RelatedProductsName || "暂无关联产品" },
            { text: "外链指向", value: item.a_LinkType || "暂无外联指向" },
          ]
           that.a_Title = item.a_Title;
          
          // that.a_ArticleContent =  decodeURIComponent(item.a_ArticleContent);
          that.a_ArticleContent =  item.a_ArticleContent;
          // decodeURIComponent(that.a_ArticleContent);
          if(item.a_ArticleTime){
            that.a_CreateTime = item.a_ArticleTime.replace(/-/g,"/").replace("T","");
          }
         
          that.imgUrl=item.a_TitleImg||"";//分享图片
          that.bondInfowx();
          // 图标路径
          if(item.a_FileIcon){
            that.fileIcon = (app.FileUoloadUrl+item.a_FileIcon).replace(app.ImagePlaceholder,app.SmallImageType);
            // that.fileIcon = " http://webtest.mobizone.cn:9537/"+item.a_FileIcon;
            console.log(item.a_FileIcon,"图标链接");
          }
          // 附件名称名称
          if(item.a_FileUrl){
            console.log(item.a_FileUrl,"附件文件");
            let pos = item.a_FileUrl.lastIndexOf(']');//'/所在的最后位置'
            let str = item.a_FileUrl.substr(pos+1)//截取文件名称字符串
            that.fileName = str;
          }
          
          // 附件路径
          if(item.a_FileUrl){
             that.fileUrl = (app.FileUoloadUrl+"images/"+item.a_FileUrl).replace(app.ImagePlaceholder,app.BigImageType);
            //  that.fileUrl = " http://webtest.mobizone.cn:9537/" + item.a_FileUrl;

            // that.fileUrl = "http://webtest.mobizone.cn:9537/uploads/1.ppt"
            // that.ConfigNametwo.url= that.fileUrl; 
            that.ConfigNametwo = {
                url: that.fileUrl,
                name: that.fileName,
                size:1048576
            }
            
            console.log(item.a_FileUrl,"附件文件");
            if( that.fileUrl.indexOf("ppt") != -1){
              that.fileIconnum = 1;
            }
            if( that.fileUrl.indexOf("pdf") != -1){
              that.fileIconnum = 2;
            }
            if( that.fileUrl.indexOf("docx") != -1 || that.fileUrl.indexOf("doc") != -1){
              that.fileIconnum = 3;
            }

          }
          // 是否支持微信转发
          if(item.a_IsCanForward){
             that.isCanForward= item.a_IsCanForward;
          }
        console.log(that.dataArrayList, "dataArrayList");
          // if (document.documentElement.clientHeight == document.documentElement.offsetHeight){
          //   setTimeout(function () {
          //     that.addSNCArticleHistory(that.a_ID,true);
          //   }, 500);
          // }
      
          // 是否显示海报
        that.isCanForwardposters = item.a_IsPoster;
        console.log(that.isCanForwardposters);
      }else{
        that.apiObj['status'] = false;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
         this.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
      // this.msg.Alert(error.ResponseMessage.ErrorMessage);
    });
  }
  /**
   * 微信转发
   */
  WxTransmit()
  {
    const that=this;
    if(!that.com.IsWeixinBrowser){//如果是微信
      that.msg.Alert("请使用微信打开");
      return;
    }
    if(that.transmitUrl){
      that.Wxzhuangfa(that.configWX);
    }else{
      this.msg.Alert("系统异常，请联系管理员");
    }
   
    // wx.showOptionMenu();//显示右上角菜单接口
  }
  /**
   * 绑定企业微信转发
   */
  bondInfowx(){
    const that=this;
    const PageName = that.router.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "AddSNCshareArticle"; 
    body.ConfigType = "view";
    body.OpType = "query";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    let typeObj = {
      "articleID":that.a_ID
    };
    
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
           that.transmitUrl=data.Status.url;
           that.guId = data.Status.guid;

           if(that.transmitUrl){
              if(that.imgUrl){
                that.imgUrl=(app.FileUoloadUrl + that.imgUrl).replace(app.ImagePlaceholder,app.SmallImageType);
                
              }
            let _config:any={
                    title: that.a_Title, // 分享标题
                    // desc: that.a_ArticleContent, // 分享描述
                    link: that.transmitUrl, // 分享链接
                    imgUrl:that.imgUrl//分享图标
                  };
                  that.configWX=_config;
                 try{
                  // wx.showOptionMenu();
                  // wx.hideOptionMenu();
                   wx.showMenuItems({
                          menuList: [
                            "menuItem:refresh",
                            // "menuItem:share:appMessage",
                            // "menuItem:share:wechat",
                            'menuItem:share:timeline', // 分享朋友圈
                          ] // 要显示的菜单项
                  });
                  that.weixin.onMenuShareTimeline(that.configWX).then(res=>{
                    console.log(res,"分享到朋友圈成功");
                      if(res){
                        const that=this;
                        const PageName = that.router.snapshot.paramMap.get('ConfigName');
                        let body = new WebParameterContext();
                        body.Account = that.com.GetAccount;
                        body.ConfigName = "AddSNCshare"; 
                        body.ConfigType = "view";
                        body.OpType = "query";
                        body.PageNumber = 1;
                        body.Client.PageName = PageName;
                        body.Client.ApiType = "Element";
                        body.Client.Name = that.element.name;
                        body.Client.ClientType = 2;
                        let typeObj = {
                          "articleID":that.a_ID,
                          "guid": that.guId
                        };
                        body.RequestBody = JSON.stringify(typeObj);
                        that.http.post(app.DEFAULTURL, body).then(data => {
                          if (data.ResponseMessage.Success) {
                            console.log()
                          }
                        }).catch(error => {
                          // console.log(error);
                          this.msg.Alert("系统异常，请联系管理员");
                        });
                      }
                    

                  }).catch(err=>{
                    console.log(err,"分享到朋友圈失败");
                  });
                 }catch(err){

                 };
              }
      }else{
        //  this.msg.Alert(data.ResponseMessage.ErrorMessage);
        console.log(data.ResponseMessage.ErrorMessage,"分享失败");
      }
    }).catch(error => {
      // console.log(error);
      this.msg.Alert("系统异常，请联系管理员");
    });
  }

  /**
   * 获取收藏状态
   */
  getCollectStatus() {
    const that = this;
    let body = {};
    body["ConfigName"] = "TBArticleCollection";
    body["ConfigType"] = "View";
    body["OpType"] = "QUERY";
    let res = {
      a_FK_SystemUser_ID: that.com.GetAccount.Id,
      e_ID: that.a_ID
    };
    body["RequestBody"] = JSON.stringify(res);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        if (data.Status.Datas.length >= 1) {
          that.isCollect = true;
        }
      } else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    })
  }

  //收藏
  addCollect() {
    const that = this;
    if(that.clickCollect){
      setTimeout(()=>{
        that.clickCollect = false;
      },500);
      return;
    }else{
      that.clickCollect = true;
    }
    let body = {};
    body["ConfigName"] = "TBArticleCollection";
    body["ConfigType"] = "form";
    body["OpType"] = "ADD";
    let res = {
      a_FK_SystemUser_ID: that.com.GetAccount.Id,
      a_FK_ArticleContent_ID: that.a_ID
    };
    body["RequestBody"] = JSON.stringify(res);
    that.http.post(app.DEFAULTURL, body).then(data => {
      setTimeout(()=>{
        that.clickCollect = false;
      },500);
      if (data.ResponseMessage.Success) {
        that.isCollect = true;
      } else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      setTimeout(()=>{
        that.clickCollect = false;
      },500);
      that.msg.Alert("添加收藏失败！");
    });
  }
  //取消收藏
  deleteCollect() {
    const that = this;
    if(that.clickCollect){
      setTimeout(()=>{
        that.clickCollect = false;
      },500);
      return;
    }else{
      that.clickCollect = true;
    }
    
    let body = {};
    body["ConfigName"] = "TBArticleCollection";
    body["ConfigType"] = "form";
    body["OpType"] = "delete";
    let res = {
      a_FK_SystemUser_ID: that.com.GetAccount.Id,
      a_FK_ArticleContent_ID: that.a_ID
    };
    body["RequestBody"] = JSON.stringify(res);
    that.http.post(app.DEFAULTURL, body).then(data => {
      setTimeout(()=>{
        that.clickCollect = false;
      },500);
      if (data.ResponseMessage.Success) {
        that.isCollect = false;
      } else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      setTimeout(()=>{
        that.clickCollect = false;
      },500);
      that.msg.Alert("取消收藏失败！");
    });
  }
 /**
  * 分享功能
  * @param config 分享配置
  */
  async Wxzhuangfa(config:any){
    const that =this;
    const actionSheet = await that.actionSheet.create({ buttons: [
    //   {
    //   text: '分享到朋友圈',
    //   icon: 'pyq',
    //   handler: () => {
    //     that.msg.Loading("分享中，请稍后...").then(load=>{
    //      let timeOut= setTimeout(()=>{
    //       load.dismiss();
    //         clearTimeout(timeOut);
    //       },2000);
    //       wx.showMenuItems({
    //         menuList: ["menuItem:refresh","menuItem:share:appMessage"] // 要显示的菜单项
    //        });
    //       that.weixin.onMenuShareTimeline(config).then(res=>{
    //         console.log(res,"分享成功");
    //         load.dismiss();
    //       }).catch(err=>{
    //         that.msg.Alert("分享失败");
    //         load.dismiss();
    //       });
    //       load.present();
    //     });
    //   }
    // }, 
    // {
    //   text: '分享到企业好友',
    //   icon: 'pyq',
    //   handler: () => {
    //    that.msg.Loading("分享中，请稍后...").then(load=>{
    //     try{
    //       that.weixin.GetMenuShareAppMessage(config).then(res=>{
    //         load.dismiss();
    //         console.log(res,"分享成功");
    //       }).catch(err=>{
    //         load.dismiss();
    //         console.log(err,"分享失败");
    //       });
    //     }catch(err){
    //       that.msg.Alert("分享异常");
    //       load.dismiss();
    //     }
    //     load.present();
    //    });
    //   }
    // },
    {
      text: '分享到企业会话',
      icon: 'pyq',
      handler: () => {
       that.msg.Loading("分享中，请稍后...").then(load=>{
        let timeOut= setTimeout(()=>{
          load.dismiss();
            clearTimeout(timeOut);
          },2000);
        that.weixin.GetshareAppMessage(config).then(res=>{
          load.dismiss();
          console.log(res,"分享成功");
        }).catch(err=>{
          load.dismiss();
          console.log(err,"分享失败");
        });
        load.present();
       });
      }
    }, {
      text: '分享到微信',
      icon: 'peoplsse',
      handler: () => {
       that.msg.Loading("分享中，请稍后...").then(load=>{
        let timeOut= setTimeout(()=>{
          load.dismiss();
            clearTimeout(timeOut);
          },2000);
        that.weixin.GetshareWechatMessage(config).then(res=>{
          load.dismiss();
          console.log(res,"分享成功");
        }).catch(err=>{
          load.dismiss();
          console.log(err,"分享失败");
        });
        load.present();
       });
      }
    }, {
      text: '取消',
      icon: 'peoplsseC',
      handler: () => {
        console.log('Cancel clicked');
      }
    }]});
    await actionSheet.present();
  }
  // 生成海报
  generatePoster(){
    const that = this;
   let body = new WebParameterContext();
    body.ConfigName = "GetQrCodeImage";
    body.OpType = "add";
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = "PotentialMembersDetail";
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    let postersAll:any={
      ID:that.a_ID, //A_ID
      QYWXQRCode:that.QYWXQRCodestyleposters,// 图片路径
    }
      body.RequestBody = JSON.stringify(postersAll);
    that.msg.Loading("加载中，请稍后").then(load=>{
      that.http.post(app.DEFAULTURL, body).then(data => {
        load.dismiss();
        if(data.ResponseMessage.Success){
          console.log(data,"结果");
          if(data.Status){
          that.QYWXQRCodestyle= (app.FileUoloadUrl+ data.Status).replace(app.ImagePlaceholder,app.BigImageType);
          that.com.setHistoryUrl();
          that.com.Go('/tabs/wechatQrcod/' + this.com.getNowDatetime,{
            QYWXQRCodestyle: that.QYWXQRCodestyle,
            type:3
         });     
          }else{
            that.msg.Alert(app.ERRORMESSAGE);
          }
        }else{
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }
    ).catch(error => {
       load.dismiss();
      that.msg.Alert(error.ResponseMessage.ErrorMessage);
      console.log(error);
    });
      load.present();
    }).catch(err=>{
      console.log(err);
    })
  }

}
